import type { Logger } from '@devhacker/shared/libs/logger';
import type { IQuizApi } from '~/types/api/quizPoll';
import { QUIZ_API_URL, API_TIMEOUT } from '~/constants/config';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';
import { errorHandler } from '~/utils/errorHandlerAuth';
import { requestInterceptors } from '~/utils/interceptorsRequestAuth';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IQuizApi => {
  const loggerInterceptors = createLoggerInterceptors($logger, 'quizzes');

  const quizFetch = createAxiosLikeFetch({
    baseURL: QUIZ_API_URL,
    timeout: API_TIMEOUT,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: '*/*',
    },
    ...loggerInterceptors,
    onRequest: [loggerInterceptors.onRequest, (config) => requestInterceptors(config)],
    onRequestError: [
      loggerInterceptors.onRequestError,
      (config) => errorHandler(config, 'quizzes'),
    ],
    onResponse: loggerInterceptors.onResponse,
    onResponseError: [
      loggerInterceptors.onResponseError,
      (config) => errorHandler(config, 'quizzes'),
    ],
  });

  return {
    getQuickPoll(quickPollId: number) {
      const url = `api/quickpolls/${quickPollId}`;
      return quizFetch(url);
    },

    setQuickPollAnswerId(quickPollAnswerId: number) {
      const url = `api/stats/answer/click/${quickPollAnswerId}`;
      return quizFetch(url, { method: 'POST' });
    },

    getQuickPollStatistics(quickPollId: number) {
      const url = `api/stats/quickpolls/full/${quickPollId}`;
      return quizFetch(url);
    },
  };
};
